<template>
<div>
  <div class="columns is-multiline">
    <div class="column is-8">
      <!-- 저장하기 -->
      <div class="btn-group-justify-end">
        <button class="button is-primary" @click="save">저장하기</button>
      </div>
      <div class="box">
        <admin-box-item title="서비스 종류 선택">
          <admin-form-item label="서비스 종류">
            <lp-radio :val.sync="tab"
                      value_name="value"
                      label_name="label"
                      :data="tabArr"></lp-radio>
          </admin-form-item>
        </admin-box-item>
      </div>
    </div>
  </div>
  <theme-service-reg ref="tab" v-if="tab===0"></theme-service-reg>
  <preorder-service-reg ref="tab1" v-if="tab===1"></preorder-service-reg>
</div>
</template>

<script>


  import ThemeServiceReg from "./ThemeServiceReg";
  import LpRadio from "../../../module/common/LpRadio";
  import PreorderServiceReg from "./PreorderServiceReg";

  export default {
    name: "service-reg",
    components: {
      PreorderServiceReg,
      LpRadio,
      ThemeServiceReg

    },
    data() {
      return {
        tab: 0,
        tabArr: [
          { label: '테마', value: 0 },
          { label: '선주문 테마', value: 1 },
        ],
      }
    },
    methods: {
      save() {
        // 테마 상품
        if(this.tab===0) {
          this.$refs.tab.saveData();
        }
        // 선주문 테마 상품
        else if(this.tab===1) {
          this.$refs.tab1.saveData();
        }
      }
    }


  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
